<section class="confirmation-dialog">
  <h2 mat-dialog-title>{{title}}</h2>

  <mat-dialog-content>
    <p>{{message}}</p>
    <p class="confirmation-question">{{question}}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      mat-button
      type="button"
      class="confirmation-dialog-cancel"
      (click)="cancel()">
      {{cancelLabel}}
    </button>
    <button
      mat-flat-button
      type="button"
      class="confirmation-dialog-confirm"
      (click)="confirm()">
      {{confirmLabel}}
    </button>
  </mat-dialog-actions>
</section>
